module.exports = __webpack_public_path__ + "img/web-05.b8c3eb6a.gif";